import { reactIcons as Icon } from '@project44/manifest-ds';

import { scopedT } from '../../../../utils/helpers/scopedT';
import { Tooltip } from '../../../Tooltip';

import { StyledIconButton } from './styles';

interface CopyButtonProps {
  onClick?: () => void;
  disabled: boolean;
}

const t = scopedT();

const CopyButton = ({ onClick, disabled }: CopyButtonProps) => {
  if (disabled) {
    return (
      <StyledIconButton
        data-testid="copy-button-disabled"
        variant="tertiary"
        onClick={onClick}
        isDisabled={disabled}
        size="small"
      >
        <Icon.CopyAll size="small" />
      </StyledIconButton>
    );
  }

  return (
    <Tooltip message={t('copyAll')} messageClicked={t('copied')}>
      <StyledIconButton
        data-testid="copy-button-icon"
        variant="tertiary"
        onClick={onClick}
        size="small"
      >
        <Icon.CopyAll size="small" />
      </StyledIconButton>
    </Tooltip>
  );
};

export default CopyButton;
